import React, {Component} from 'react';
import AlertMessage from "../Common/Alert/AlertMessage";

class ErrorBoundary extends Component {

    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    render() {
        if (this.state.hasError) {
            return <AlertMessage message={'Something went wrong'} severity={'error'} />;
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
